import { Instagram } from "lucide-react";

export const SOCIALS = [
  { key: "instagram", label: "Instagram", handle: "@mapetiteligue", url: "https://www.instagram.com/mapetiteligue", Icon: Instagram },
  { key: "x", label: "X (Twitter)", handle: "@mapetiteligue", url: "https://x.com/mapetiteligue", Icon: XLogo },
];

export function XLogo({ size = 16, className = "" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
      <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
    </svg>
  );
}

export function SocialLinks({ onOpen, done = {}, testPrefix = "social", bonus = false }) {
  return (
    <div className="grid gap-3 sm:grid-cols-2">
      {SOCIALS.map(({ key, label, handle, url, Icon }) => (
        <a key={key} href={url} target="_blank" rel="noopener noreferrer" onClick={() => onOpen?.(key)}
          className="group flex items-center gap-3 rounded-2xl border border-white/10 bg-white/[0.04] p-4 transition-colors hover:border-[#B7F52A]/60 hover:bg-white/[0.07]"
          data-testid={`${testPrefix}-${key}`}>
          <span className="grid h-11 w-11 shrink-0 place-items-center rounded-xl bg-[#B7F52A] text-[#101310]"><Icon size={20} /></span>
          <span className="min-w-0 flex-1"><b className="block text-sm text-white">{label}</b><span className="text-xs text-slate-400">{handle}{bonus && <span className="ml-1.5 font-bold text-[#B7F52A]">+15 pts</span>}</span></span>
          <span className="text-xs font-bold uppercase tracking-wide text-[#B7F52A]">{done[key] ? "Suivi ✓" : "Suivre →"}</span>
        </a>))}
    </div>
  );
}
